/**
 * Nav model for the tenant staff console. Three ordered groups
 * (Reports / Synchronization / Configuration). Icon values are Material
 * Symbols ligature names. No badges. No notification bell.
 */

export interface NavItem {
  to: string;
  key: string;
  fallback: string;
  icon: string;
  end?: boolean;
}

export interface NavGroup {
  groupKey: string;
  groupFallback: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    groupKey: 'nav.group.reports',
    groupFallback: 'Reports',
    items: [
      { to: '/', key: 'nav.dashboard', fallback: 'Dashboard', icon: 'dashboard', end: true },
      { to: '/reports/membership', key: 'nav.membershipStats', fallback: 'Membership Stats', icon: 'card_membership' },
      { to: '/reports/revenue', key: 'nav.revenueStats', fallback: 'Revenue Stats', icon: 'query_stats' },
    ],
  },
  {
    groupKey: 'nav.group.synchronization',
    groupFallback: 'Synchronization',
    items: [
      { to: '/users', key: 'nav.users', fallback: 'Users', icon: 'group' },
      { to: '/sales', key: 'nav.sales', fallback: 'Sales', icon: 'payments' },
      { to: '/attendance', key: 'nav.attendance', fallback: 'Attendance', icon: 'event_available' },
      { to: '/products', key: 'nav.products', fallback: 'Products', icon: 'inventory_2' },
    ],
  },
  {
    groupKey: 'nav.group.configuration',
    groupFallback: 'Configuration',
    items: [
      { to: '/sync-reports', key: 'nav.syncReports', fallback: 'Sync Reports', icon: 'sync' },
      { to: '/configuration', key: 'nav.configuration', fallback: 'Configuration', icon: 'settings' },
      { to: '/team', key: 'nav.teamAndAccess', fallback: 'Team & access', icon: 'manage_accounts' },
      { to: '/engine', key: 'nav.engine', fallback: 'Engine', icon: 'memory' },
    ],
  },
];
